import request from '@/utils/request'

// 获取文章列表
export function getArticles(params) {
  return request({
    url: '/api/articles',
    method: 'get',
    params
  })
}

// 获取文章详情
export function getArticle(articleCode) {
  return request({
    url: `/api/articles/${articleCode}`,
    method: 'get'
  })
}

// 创建文章
export function createArticle(data) {
  return request({
    url: '/api/articles',
    method: 'post',
    data
  })
}

// 更新文章
export function updateArticle(articleCode, data) {
  return request({
    url: `/api/articles/${articleCode}`,
    method: 'put',
    data
  })
}

// 删除文章
export function deleteArticle(articleCode) {
  return request({
    url: `/api/articles/${articleCode}`,
    method: 'delete'
  })
} 

// 更新文章发布状态
export function updateArticlePushStatus(articleCode, isPush) {
  return request({
    url: `/api/articles/${articleCode}/push`,
    method: 'put',
    data: { is_push: isPush }
  })
}

// 更新文章置顶状态
export function updateArticleTopStatus(articleCode, isTop) {
  return request({
    url: `/api/articles/${articleCode}/top`,
    method: 'put',
    data: { is_top: isTop }
  })
}

// 获取博客文章列表(公开的文章)
export function getBlogArticles(params) {
  return request({
    url: '/api/blog/articles',
    method: 'get',
    params
  })
}

// 获取博客文章详情(公开的文章)
export function getBlogArticle(articleCode, password) {
  const params = password ? { password } : {}
  return request({
    url: `/api/blog/articles/${articleCode}`,
    method: 'get',
    params
  })
}

// 增加文章阅读量
export function increaseArticleReadCount(articleCode) {
  return request({
    url: `/api/blog/articles/${articleCode}/read`,
    method: 'put'
  })
}

// 设置/修改文章密码
export function setArticlePassword(articleCode, password) {
  return request({
    url: `/api/articles/${articleCode}/password`,
    method: 'put',
    data: { password }
  })
}

// 取消文章密码
export function removeArticlePassword(articleCode, password) {
  return request({
    url: `/api/articles/${articleCode}/password`,
    method: 'delete',
    data: { password }
  })
}

// 验证文章密码（公开接口）
export function verifyArticlePassword(articleCode, password) {
  return request({
    url: `/api/articles/${articleCode}/password/verify`,
    method: 'post',
    data: { password }
  })
} 